import * as React from 'react';

/**
 * Call outcome as a pill, shared by the detail and retailer reports.
 * Both screens previously rendered the raw enum ("WRONG_NUMBER") as plain
 * text in a column of identical-looking values.
 */
export const statusPill = (callStatus: string) => {
  const label = (callStatus || '').split('_').join(' ') || 'Unknown';
  const variant = callStatus === 'ANSWERED' ? 'answered'
    : callStatus === 'NO_REPLY' ? 'noreply'
    : callStatus === 'WRONG_NUMBER' ? 'wrong' : 'other';
  return <span className={`cs-rep__status cs-rep__status--${variant}`}>{label}</span>;
};
